import { HttpPostRequest } from '@infrastructure/axios/http-post-request';
import { ContactWithUsPayload, ISendContactWithUsRequirement, ContactWithUsResponse } from '../../interfaces/sendcontactwithusrequirement';

export default class SendContactWithUsRequirementUseCase extends HttpPostRequest<ContactWithUsPayload, ContactWithUsResponse> implements ISendContactWithUsRequirement {
  public async execute(payload: ContactWithUsPayload): Promise<ContactWithUsResponse> {
    return (await this.dispatch('/support', payload)).data.data;
  }
}
